import React, { useMemo } from 'react';
import styles from '../../styles/ReportesFinancierosStyles/ReportesFinancieros.module.css';

function ReportTable({ estudiantes = [], filters = {} }) {
  const today = new Date().toLocaleDateString('es-MX', {
    year: 'numeric', month: 'long', day: 'numeric'
  });

  const metaItems = useMemo(() => {
    const items = [];
    if (estudiantes.length > 0) {
      const first = estudiantes[0];
      if (filters.id_campus && first.campus_nombre) items.push({ label: 'Campus', value: first.campus_nombre });
      if (filters.id_seccion && first.seccion_nombre) items.push({ label: 'Sección', value: first.seccion_nombre });
      if (filters.id_programa && first.programa_nombre) items.push({ label: 'Programa', value: first.programa_nombre });
    }
    if (filters.anio) items.push({ label: 'Año', value: filters.anio });
    return items;
  }, [estudiantes, filters]);

  const formatCurrency = (val) => {
    if (val === null || val === undefined) return '—';
    return `$${Number(val).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  if (!estudiantes || estudiantes.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>📋</div>
        <p className={styles.emptyText}>No se encontraron estudiantes con becas para los filtros seleccionados</p>
      </div>
    );
  }

  return (
    <>
      <div className={styles.reportMeta}>
        {metaItems.map((item, i) => (
          <div key={i} className={styles.reportMetaItem}>
            <span className={styles.reportMetaLabel}>{item.label}:</span>
            <span>{item.value}</span>
          </div>
        ))}
        <div className={styles.reportDate}>
          <span className={styles.reportDateLabel}>Fecha del Reporte: </span>
          <span>{today}</span>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.reportTable}>
          <thead>
            <tr>
              <th>Matrícula</th>
              <th>Nombre del Estudiante</th>
              <th>Tipo de Beca</th>
              <th className={styles.cellRight}>Porcentaje de Beca</th>
              <th className={styles.cellRight}>Monto de Beca</th>
              <th>Ciclo Escolar Ingreso</th>
              <th>Fecha Inicio Beca</th>
              <th>Fecha Término Beca</th>
              <th className={styles.cellRight}>Costo Colegiatura (Parcialidad)</th>
              <th className={styles.cellRight}>Cantidad que Paga el Estudiante</th>
              <th className={styles.cellRight}>Cantidad Pagada en el Año</th>
            </tr>
          </thead>
          <tbody>
            {estudiantes.map((e, index) => (
              <tr key={`${e.matricula}-${index}`}>
                <td>{e.matricula || '—'}</td>
                <td>{e.nombre_completo || '—'}</td>
                <td>{e.nombre_beca || e.tipo_beca || '—'}</td>
                <td className={styles.cellRight}>
                  {e.porcentaje_otorgado ? `${e.porcentaje_otorgado}%` : '—'}
                </td>
                <td className={styles.cellRight}>
                  {e.monto_beca_asignado ? formatCurrency(e.monto_beca_asignado) : '—'}
                </td>
                <td>{e.ciclo_ingreso || '—'}</td>
                <td>{e.fecha_inicio || '—'}</td>
                <td>{e.fecha_fin || '—'}</td>
                <td className={styles.cellRight}>{formatCurrency(e.costo_colegiatura_parcialidad)}</td>
                <td className={styles.cellRight}>{formatCurrency(e.cantidad_pagada_estudiante)}</td>
                <td className={styles.cellRight}>{formatCurrency(e.cantidad_pago_anual)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReportTable;
